// stages/CodeVerificationStage.js
import React from 'react';

const CodeVerificationStage = ({ 
  contactEmail, 
  verificationCode, 
  setVerificationCode, 
  verifyCode, 
  isVerifying 
}) => {
  return (
    <div className="stage">
      <h2 className="stage-title">Check Your Email</h2>

      <div className="verification-section">
        <p>We've sent a 6-digit code to your inbox.</p>
        <div className="email-display">{contactEmail}</div>

        <div className="code-input-section">
          <label>Enter Verification Code</label>
          <input
            type="text"
            placeholder="000000"
            value={verificationCode}
            onChange={(e) => setVerificationCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
            className="code-input"
            maxLength="6"
          />
          <p className="code-hint">Enter the code from your email. It expires in 30 minutes.</p>
        </div>

        <div className="verification-help">
          <p>If the email hasn't arrived, check your spam folder. If it's still missing, email <a href="mailto:aski3@i3solutions.com">aski3@i3solutions.com</a> and we'll resend it.</p>
        </div>
      </div>
      
      <div className="text-center">
        <button 
          className="btn-primary"
          onClick={verifyCode}
          disabled={isVerifying || verificationCode.length !== 6}
        >
          {isVerifying ? 'Verifying...' : 'Access My Report'}
        </button>
      </div>
    </div>
  );
};

export default CodeVerificationStage;